// Combined Refill Product Handler - Vanilla JavaScript
(function() {
    'use strict';

    // Utility functions to replace jQuery functionality
    const utils = {
        ready: function(callback) {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', callback);
            } else {
                callback();
            }
        },

        on: function(selector, event, handler) {
            document.addEventListener(event, function(e) {
                if (e.target.matches(selector) || e.target.closest(selector)) {
                    const target = e.target.matches(selector) ? e.target : e.target.closest(selector);
                    handler.call(target, e);
                }
            });
        },

        find: function(selector) {
            return document.querySelectorAll(selector);
        },

        findOne: function(selector) {
            return document.querySelector(selector);
        },

        addClass: function(elements, className) {
            if (NodeList.prototype.isPrototypeOf(elements)) {
                elements.forEach(el => el.classList.add(className));
            } else if (elements) {
                elements.classList.add(className);
            }
        },

        removeClass: function(elements, className) {
            if (NodeList.prototype.isPrototypeOf(elements)) {
                elements.forEach(el => el.classList.remove(className));
            } else if (elements) {
                elements.classList.remove(className);
            }
        },

        toggleClass: function(element, className) {
            if (element) {
                element.classList.toggle(className);
            }
        },

        hasClass: function(element, className) {
            return element ? element.classList.contains(className) : false;
        },

        attr: function(element, attr, value) {
            if (value !== undefined) {
                if (element) element.setAttribute(attr, value);
            } else {
                return element ? element.getAttribute(attr) : null;
            }
        },

        prop: function(element, prop, value) {
            if (value !== undefined) {
                if (element) element[prop] = value;
            } else {
                return element ? element[prop] : null;
            }
        },

        closest: function(element, selector) {
            return element ? element.closest(selector) : null;
        },

        text: function(element, value) {
            if (value !== undefined) {
                if (element) element.textContent = value;
            } else {
                return element ? element.textContent : '';
            }
        }
    };

    // Initialize handlers for different product types
    function initRefillHandlers() {
        initVisoHandler();
        initPlumpHandler();
        initRossettiHandler();
    }

    // VISO Product Handler
    function initVisoHandler() {
        let intervalRefillViso = setInterval(function() {
            const visoFieldsets = utils.find('.refill--viso #infiniteoptions-container fieldset');
            if (visoFieldsets.length > 0) {
                clearInterval(intervalRefillViso);
                refillAutomatorOptionsViso();
            }
        }, 1000);

        
        // Event handler for viso options
        utils.on('.refill-pane--default fieldset .spb-productoptiontextcolor', 'change', function(e) {
            const label = utils.closest(this, 'label');
            const labelBg = utils.attr(label, 'data-bg');
            const checkedInputs = utils.find('.spb-productoptiontextcolor:checked');
            
            // Get count choices to determine if it's 2 or 4 colors
            const countChoices = utils.findOne('.ProductRefill > div')?.dataset?.choices || '2';
            const maxChoices = parseInt(countChoices);

            console.log(checkedInputs, 'Max choices:', maxChoices);
            
            if (checkedInputs.length <= maxChoices) {
                const allInputs = utils.find('.refill-pane--default fieldset > label > input');
                allInputs.forEach(input => utils.prop(input, 'disabled', false));
                
                if (utils.hasClass(label, 'is-checked')) {
                    const refillColors = utils.find(`.ProductRefill__color[data-bg='${labelBg}']`);
                    refillColors.forEach(color => {
                        utils.attr(color, 'style', '');
                        utils.attr(color, 'data-bg', '');
                    });
                } else {
                    const color1 = utils.findOne('.ProductRefill__color.color-1');
                    const color2 = utils.findOne('.ProductRefill__color.color-2');
                    
                    if (maxChoices === 4) {
                        // Gestione per 4 colori
                        const color3 = utils.findOne('.ProductRefill__color.color-3');
                        const color4 = utils.findOne('.ProductRefill__color.color-4');
                        
                        if (utils.attr(color1, 'data-bg') === '') {
                            utils.attr(color1, 'data-bg', labelBg);
                            utils.attr(color1, 'style', `background-image:url(${labelBg})`);
                        } else if (utils.attr(color2, 'data-bg') === '') {
                            utils.attr(color2, 'data-bg', labelBg);
                            utils.attr(color2, 'style', `background-image:url(${labelBg})`);
                        } else if (utils.attr(color3, 'data-bg') === '') {
                            utils.attr(color3, 'data-bg', labelBg);
                            utils.attr(color3, 'style', `background-image:url(${labelBg})`);
                        } else if (utils.attr(color4, 'data-bg') === '') {
                            utils.attr(color4, 'data-bg', labelBg);
                            utils.attr(color4, 'style', `background-image:url(${labelBg})`);
                        }
                    } else {
                        // Gestione per 2 colori (comportamento originale)
                        if (utils.attr(color1, 'data-bg') === '') {
                            utils.attr(color1, 'data-bg', labelBg);
                            utils.attr(color1, 'style', `background-image:url(${labelBg})`);
                        } else if (utils.attr(color2, 'data-bg') === '') {
                            utils.attr(color2, 'data-bg', labelBg);
                            utils.attr(color2, 'style', `background-image:url(${labelBg})`);
                        }
                    }
                }
                
                utils.toggleClass(label, 'is-checked');
                
                if (checkedInputs.length === maxChoices) {
                    const uncheckedInputs = utils.find('.refill-pane--default fieldset > label:not(.is-checked) > input');
                    uncheckedInputs.forEach(input => utils.prop(input, 'disabled', true));
                    
                    utils.addClass(utils.findOne('.refill-pane--default'), 'input-disabled');
                    utils.addClass(utils.findOne('.refillError'), 'is-visible');

                    // Enable cart button when max choices are selected
                    const addToCartBtn = document.querySelector('.product-form__submit');
                    if (addToCartBtn) {
                        addToCartBtn.disabled = false;
                        utils.removeClass(addToCartBtn, 'is-disabled');
                    }
                } else {
                    utils.removeClass(utils.findOne('.refill-pane--default'), 'input-disabled');
                    utils.removeClass(utils.findOne('.refillError'), 'is-visible');

                    // Disable cart button if not exactly max choices selected
                    const addToCartBtn = document.querySelector('.product-form__submit');
                    if (addToCartBtn) {
                        addToCartBtn.disabled = true;
                        utils.addClass(addToCartBtn, 'is-disabled');
                    }
                }
            }
        });
    }

    function refillAutomatorOptionsViso() {
        // Disable cart button initially
        const addToCartBtn = document.querySelector('.product-form__submit');
        if (addToCartBtn) {
            addToCartBtn.disabled = true;
            utils.addClass(addToCartBtn, 'is-disabled');
        }

        const containers = utils.find('.refill--viso #infiniteoptions-container > div');
        containers.forEach((container, i) => {
            utils.addClass(container, `item-${i}`);
        });

        const labels = utils.find('.refill--viso #infiniteoptions-container fieldset label');
        labels.forEach(label => {
            const assetFolders = 'https://cdn.shopify.com/s/files/1/0286/5712/3433/t/34/assets/';
            const assetFoldersNew = 'https://cdn.shopify.com/s/files/1/0286/5712/3433/t/35/assets/';
            const assetFoldersDedicata = 'https://diegodallapalma.com/cdn/shop/t/52/assets/';
            const optColor = label.querySelector('.spb-productoptiontextcolor')?.value;
            const legend = label.closest('fieldset')?.querySelector('legend');
            const singleVariant = utils.text(legend);
            
            let imgUrl;
            if (singleVariant === 'COLORI OPACHI') {
                imgUrl = assetFolders + optColor + '_OPACO_600x.png';
            } else if (singleVariant === 'COLORI PERLATI') {
                imgUrl = assetFolders + optColor + '_PERLATO_600x.png';
            } else if (singleVariant === 'ABBRONZANTE' || singleVariant === 'BRONZER') {
                imgUrl = assetFolders + optColor + '_ABBRONZANTE.jpg';
            } else if (singleVariant === 'ILLUMINANTE' || singleVariant === 'HIGHLIGHTER') {
                imgUrl = assetFolders + optColor + '_ILLUMINANTE.jpg';
            } else if (singleVariant === 'FONDOTINTA' || singleVariant === 'Foundations') {
                imgUrl = assetFoldersDedicata + optColor + '_FONDOTINTA.jpg';
            } else if (singleVariant === 'BLUSH') {
                imgUrl = assetFoldersDedicata + optColor + '__BLUSH.png';
            } else {
                imgUrl = assetFolders + optColor + '_POLVERE.jpg';
            }
            
            utils.attr(label, 'data-bg', imgUrl);
            utils.attr(label, 'style', `background-image:url(${imgUrl})`);
            utils.attr(label, 'title', optColor);
            
            const codeSpan = document.createElement('span');
            codeSpan.className = 'code';
            codeSpan.textContent = utils.text(label).substr(-3);
            label.appendChild(codeSpan);
        });
    }

    // PLUMP Product Handler
    function initPlumpHandler() {
        let interval = setInterval(function() {
            const plumpFieldsets = utils.find('.refill-pane--plump #infiniteoptions-container fieldset');
            if (plumpFieldsets.length > 0) {
                clearInterval(interval);
                refillAutomatorOptionsPlump();
            }
        }, 500);

        // Event handler for plump options
        utils.on('.refill-pane--plump fieldset .spb-productoptiontextcolor', 'change', function(e) {
            const label = utils.closest(this, 'label');
            const labelBg = utils.attr(label, 'data-img-refill'); // Corretto: usa data-img-refill
            const messageText = utils.attr(utils.findOne('.refillError'), 'data-message');
            const fieldset = utils.closest(label, 'fieldset');

            if (utils.hasClass(fieldset, 'type-of-color')) {
                const color1 = utils.findOne('.ProductRefill__color.color-1');
                utils.attr(color1, 'style', '');
                utils.attr(color1, 'data-bg', '');

                if (utils.hasClass(label, 'is-checked')) {
                    utils.removeClass(label, 'is-checked');
                } else {
                    utils.toggleClass(label, 'is-checked');
                    utils.prop(utils.findOne('input', label), 'checked', true);
                    
                    // Controllo se l'immagine per il refill è presente
                    if (labelBg !== '') {
                        utils.attr(color1, 'data-bg', labelBg);
                        utils.attr(color1, 'style', `background-image:url(${labelBg})`);
                    }
                }

                // Controlla se 1 colore è selezionato
                const checkedColorInputs = utils.find('.refill-pane--plump .type-of-color input[type=checkbox]:checked');
                if (checkedColorInputs.length === 1) {
                    const uncheckedInputs = utils.find('fieldset.type-of-color label:not(.is-checked) input');
                    const uncheckedLabels = utils.find('fieldset.type-of-color label:not(.is-checked)');
                    uncheckedInputs.forEach(input => utils.prop(input, 'disabled', true));
                    uncheckedLabels.forEach(label => utils.addClass(label, 'is-disabled'));
                } else {
                    const allInputs = utils.find('fieldset.type-of-color label input');
                    const allLabels = utils.find('fieldset.type-of-color label');
                    allInputs.forEach(input => utils.prop(input, 'disabled', false));
                    allLabels.forEach(label => utils.removeClass(label, 'is-disabled'));
                }
            } else {
                // Gestione case
                if (utils.hasClass(label, 'is-checked')) {
                    utils.removeClass(label, 'is-checked');
                    const color2Elements = utils.find(`.ProductRefill__color.color-2[data-bg='${labelBg}']`);
                    color2Elements.forEach(color => {
                        utils.attr(color, 'style', '');
                        utils.attr(color, 'data-bg', '');
                    });
                } else {
                    // Rimuove tutte le selezioni case precedenti
                    const caseLabels = utils.find('.type-of-case label');
                    const caseInputs = utils.find('.type-of-case label.is-checked input');
                    caseLabels.forEach(label => utils.removeClass(label, 'is-checked'));
                    caseInputs.forEach(input => utils.prop(input, 'checked', false));

                    utils.toggleClass(label, 'is-checked');
                    utils.prop(utils.findOne('input', label), 'checked', true);

                    const color2 = utils.findOne('.ProductRefill__color.color-2');
                    utils.attr(color2, 'data-bg', labelBg);
                    utils.attr(color2, 'style', `background-image:url(${labelBg})`);
                }

                const checkedCaseInputs = utils.find('.refill-pane--plump .type-of-case input[type=checkbox]:checked');
                if (checkedCaseInputs.length === 1) {
                    const uncheckedLabels = utils.find('fieldset.type-of-case label:not(.is-checked)');
                    uncheckedLabels.forEach(label => utils.addClass(label, 'is-disabled'));
                } else {
                    const allLabels = utils.find('fieldset.type-of-case label');
                    allLabels.forEach(label => utils.removeClass(label, 'is-disabled'));
                }
            }

            // Enable/disable cart button - Corretto: usa product-form__submit
            const caseChecked = utils.find('.type-of-case label.is-checked input');
            const colorChecked = utils.find('.type-of-color label.is-checked input');

            console.log(caseChecked, colorChecked);
            
            if (caseChecked.length === 1 && colorChecked.length !== 0) {
                const addToCartBtn = utils.findOne('.product-form__submit:not(.Button--temporary)');
                if (addToCartBtn) {
                    utils.prop(addToCartBtn, 'disabled', false);
                    utils.removeClass(addToCartBtn, 'is-disabled');
                }
                utils.removeClass(utils.findOne('.refillError'), 'is-visible');
            } else {
                utils.text(utils.findOne('.refillError'), messageText);
                const addToCartBtn = utils.findOne('.product-form__submit');
                if (addToCartBtn) {
                    utils.prop(addToCartBtn, 'disabled', true);
                    utils.addClass(addToCartBtn, 'is-disabled');
                }
                utils.addClass(utils.findOne('.refillError'), 'is-visible');
            }
        });
    }

    function refillAutomatorOptionsPlump() {
        // Disable cart - Corretto: usa product-form__submit
        const addToCartBtn = utils.findOne('.product-form__submit');
        if (addToCartBtn) {
            utils.prop(addToCartBtn, 'disabled', true);
            utils.addClass(addToCartBtn, 'is-disabled');
        }

        // Find container options
        const containers = utils.find('.refill-pane--plump #infiniteoptions-container > div');
        containers.forEach((container, i) => {
            const hiddenInput = container.querySelector('input[type=hidden]');
            const attrname = hiddenInput.getAttribute('name');
            
            if (attrname === 'properties[plump&fill]') {
                const fieldset = container.querySelector('fieldset');
                fieldset.classList.add('type-of-color');
                container.classList.add('item-shade');
            } else {
                const fieldset = container.querySelector('fieldset');
                fieldset.classList.add('type-of-case');
                container.classList.add('item-case');
            }
            container.classList.add(`item-${i}`);
        });

        const labels = utils.find('#infiniteoptions-container fieldset label');
        labels.forEach(label => {
            const assetUrlElement = document.querySelector('.ProductRefill--plump');
            const assetFolder = assetUrlElement.getAttribute('data-asset-url');
            const restAssetFolder = assetFolder.substring(0, assetFolder.lastIndexOf("/") + 1);
            
            const optColor = label.querySelector('.spb-productoptiontextcolor').value;
            const codeOptColor = optColor.substring(0, 3);
            const legend = label.closest('fieldset').querySelector('legend');
            const singleVariant = legend.textContent.toLowerCase().replace(/\s/g, "-");
            
            const pathCdn = "//diegodallapalma.com/cdn/shop/files/";
            const imgUrl = pathCdn + optColor.replace(/\s/g, "-") + '.png';
            
            let imgRefill = '';
            let dataCode = '';
            
            if (singleVariant === "taste-my-lips") {
                imgRefill = restAssetFolder + codeOptColor + '__LIPOIL.png';
                dataCode = 'DF104' + codeOptColor;
            } else if (singleVariant === "protect-my-lips") {
                imgRefill = restAssetFolder + codeOptColor + '__BALSAMO.png';
                dataCode = 'DF104' + codeOptColor;
            } else if (singleVariant === "boost-my-lips") {
                imgRefill = '';
            } else {
                imgRefill = restAssetFolder + codeOptColor + '__MATITA.png';
                dataCode = 'DF113' + codeOptColor;
            }
            
            utils.attr(label, 'data-bg', imgUrl);
            utils.attr(label, 'data-img-refill', imgRefill);
            utils.attr(label, 'style', `background-image:url(${imgUrl})`);
            utils.attr(label, 'title', optColor);
            utils.attr(label, 'data-code', dataCode);
            
            const codeSpan = document.createElement('span');
            codeSpan.className = 'code';
            codeSpan.textContent = dataCode;
            label.appendChild(codeSpan);

            // Handle boost-my-lips special case - Corretto: usa trigger('click')
            if (utils.attr(label, 'data-img-refill') === '') {
                const checkbox = label.querySelector('input[type="checkbox"]');
                checkbox.click(); // Simula il trigger('click')
                utils.prop(checkbox, 'disabled', true);
                utils.addClass(label, 'is-disabled');
            }
        });
    }

    // ROSSETTI Product Handler
    function initRossettiHandler() {
        let interval = setInterval(function() {
            const rossettiFieldsets = utils.find('.refill-pane--rossetti #infiniteoptions-container fieldset');
            if (rossettiFieldsets.length > 0) {
                clearInterval(interval);
                refillAutomatorOptionsRossetti();
            }
        }, 500);

        // Event handler for rossetti options
        utils.on('.refill-pane--rossetti fieldset .spb-productoptiontextcolor', 'change', function(e) {
            const label = utils.closest(this, 'label');
            const labelBg = utils.attr(label, 'data-bg');
            const messageText = utils.attr(utils.findOne('.refillError'), 'data-message');
            const fieldset = utils.closest(label, 'fieldset');

            if (utils.hasClass(fieldset, 'type-of-color')) {
                const color1 = utils.findOne('.ProductRefill__color.color-1');
                utils.attr(color1, 'style', '');
                utils.attr(color1, 'data-bg', '');

                if (utils.hasClass(label, 'is-checked')) {
                    utils.removeClass(label, 'is-checked');
                } else {
                    utils.toggleClass(label, 'is-checked');
                    utils.prop(utils.findOne('input', label), 'checked', true);

                    utils.attr(color1, 'data-bg', labelBg);
                    utils.attr(color1, 'style', `background-image:url(${labelBg})`);
                }

                // Check if 1 color is selected to disable other options
                const checkedColorInputs = utils.find('.refill-pane--rossetti .type-of-color label.is-checked input');
                console.log(checkedColorInputs)
                if (checkedColorInputs.length === 1) {
                    const uncheckedInputs = utils.find('fieldset.type-of-color label:not(.is-checked) input');
                    const uncheckedLabels = utils.find('fieldset.type-of-color label:not(.is-checked)');
                    uncheckedInputs.forEach(input => utils.prop(input, 'disabled', true));
                    uncheckedLabels.forEach(label => utils.addClass(label, 'is-disabled'));
                } else {
                    const allInputs = utils.find('fieldset.type-of-color label input');
                    const allLabels = utils.find('fieldset.type-of-color label');
                    allInputs.forEach(input => utils.prop(input, 'disabled', false));
                    allLabels.forEach(label => utils.removeClass(label, 'is-disabled'));
                }
            } else {
                // Case selection logic
                if (utils.hasClass(label, 'is-checked')) {
                    utils.removeClass(label, 'is-checked');
                    const color2Elements = utils.find(`.ProductRefill__color.color-2[data-bg='${labelBg}']`);
                    color2Elements.forEach(color => {
                        utils.attr(color, 'style', '');
                        utils.attr(color, 'data-bg', '');
                    });
                } else {
                    // Remove all case selections first
                    const caseLabels = utils.find('.type-of-case label');
                    const caseInputs = utils.find('.type-of-case label.is-checked input');

                    caseLabels.forEach(label => utils.removeClass(label, 'is-checked'));
                    caseInputs.forEach(input => utils.prop(input, 'checked', false));

                    utils.toggleClass(label, 'is-checked');
                    utils.prop(utils.findOne('input', label), 'checked', true);

                    const color2 = utils.findOne('.ProductRefill__color.color-2');
                    utils.attr(color2, 'data-bg', labelBg);
                    utils.attr(color2, 'style', `background-image:url(${labelBg})`);
                }
                
                const checkedCaseInputs = utils.find('.refill-pane--rossetti .type-of-case label.is-checked input');
                
                console.log(checkedCaseInputs)
                
                if (checkedCaseInputs.length === 1) {
                    const uncheckedLabels = utils.find('fieldset.type-of-case label:not(.is-checked)');
                    uncheckedLabels.forEach(label => utils.addClass(label, 'is-disabled'));
                } else {
                    const allLabels = utils.find('fieldset.type-of-case label');
                    allLabels.forEach(label => utils.removeClass(label, 'is-disabled'));
                }
            }

            // Enable/disable cart button
            const caseChecked = utils.find('.type-of-case label.is-checked input');
            const colorChecked = utils.find('.type-of-color label.is-checked input');

            if (caseChecked.length === 1 && colorChecked.length === 1) {
                const addToCartBtn = utils.findOne('.product-form__submit:not(.Button--temporary)');
                if (addToCartBtn) {
                    utils.prop(addToCartBtn, 'disabled', false);
                    utils.removeClass(addToCartBtn, 'is-disabled');
                }
                utils.removeClass(utils.findOne('.refillError'), 'is-visible');
            } else {
                utils.text(utils.findOne('.refillError'), messageText);
                const addToCartBtn = utils.findOne('.product-form__submit');
                if (addToCartBtn) {
                    utils.prop(addToCartBtn, 'disabled', true);
                    utils.addClass(addToCartBtn, 'is-disabled');
                }
                utils.addClass(utils.findOne('.refillError'), 'is-visible');
            }
        });
    }

    function refillAutomatorOptionsRossetti() {
        // Disable cart initially
        const addToCartBtn = utils.findOne('.product-form__submit');
        if (addToCartBtn) {
            utils.prop(addToCartBtn, 'disabled', true);
            utils.addClass(addToCartBtn, 'is-disabled');
        }

        // Find container options
        const containers = utils.find('.refill-pane--rossetti #infiniteoptions-container > div');
        containers.forEach((container, i) => {
            const hiddenInput = container.querySelector('input[type=hidden]');
            const attrname = hiddenInput.getAttribute('name');
            
            if (attrname === 'properties[finish-lumi-matt]' || 
                attrname === 'properties[finish-creamy]' || 
                attrname === 'properties[color-nude-caldi]' || 
                attrname === 'properties[color-nude-freddi]' || 
                attrname === 'properties[color-rossi]') {
                const fieldset = container.querySelector('fieldset');
                fieldset.classList.add('type-of-color');
                container.classList.add('item-shade');
            } else {
                const fieldset = container.querySelector('fieldset');
                fieldset.classList.add('type-of-case');
                container.classList.add('item-case');
            }
            container.classList.add(`item-${i}`);
        });

        const labels = utils.find('#infiniteoptions-container fieldset label');
        labels.forEach(label => {
            const assetUrlElement = document.querySelector('.ProductRefill--rossetti');
            const assetFolder = assetUrlElement.getAttribute('data-asset-url');
            const restAssetFolder = assetFolder.substring(0, assetFolder.lastIndexOf("/") + 1);
            
            const optColor = label.querySelector('.spb-productoptiontextcolor').value;
            const legend = label.closest('fieldset').querySelector('legend');
            const singleVariant = legend.textContent;
            
            let imgUrl;
            if (singleVariant === 'CASE') {
                imgUrl = restAssetFolder + optColor + '_CASE.png';
            } else {
                imgUrl = restAssetFolder + optColor + '_ROSSETTO.png';
            }
            
            utils.attr(label, 'data-bg', imgUrl);
            utils.attr(label, 'style', `background-image:url(${imgUrl})`);
            utils.attr(label, 'title', optColor);
            
            const codeSpan = document.createElement('span');
            codeSpan.className = 'code';
            codeSpan.textContent = utils.text(label).substr(-2);
            label.appendChild(codeSpan);
        });
    }

    // Initialize when DOM is ready
    utils.ready(function() {
        initRefillHandlers();
    });

})();